import React from 'react';

import { MCButton, Spinner, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
  formatDuration,
  withRouter,
  lang,
  scssVariables as variables,
  permissions,
  deviceIsMobile
} from 'src/helpers';

import model from './model';
import AlertManager from 'src/components/alert';
import LANG_CONST from 'src/helpers/lang/const';
import { remCss } from 'src/helpers';

const intervalId = 'EmailVerification';

let router = null;

class EmailVerification extends BaseComponent {
  state = { resend: false, loading: true, id: null, msg: null };

  componentDidMount() {
    console.log('email verification component mounted');
    router = this.props.router;
    model.subscribe(this.subscription);

    if (model.state.user?.emailVerified) return permissions.afterLogin(model.state.user);

    const id = new URLSearchParams(this.props.router.location.search).get('id');

    if (id && id !== model.state.verifyId) {
      this.setState({ loading: true, id });
      model.verify(id, (error, data) => {
        console.log('email verify', { id, error, data });

        if (data.session) {
          if (deviceIsMobile) {
            model.emit('auth', data.session);
            return this.setState({ msg: LANG_CONST.notice.email_verified, loading: false });
          }
          model.emit('auth', data.session);
          // permissions.afterLogin(data.session.user);
          this.showSuccessPopup();
        } else {
          this.setState({ loading: false, resend: true });
          setTimeout(() => {
            model.setInvalidApi('requestVerification', {
              email: LANG_CONST.validation.link_invalid
            });
          }, 100);
        }
      });
    } else {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    console.log('email verification component unmounted');
    model.unsubscribe(this.subscription);
  }

  showSuccessPopup = () => {
    AlertManager.popup(
      AlertManager.TYPES.INFO,
      {
        title: LANG_CONST.notice.email_verified,
        actionButton: {
          label: LANG_CONST.buttons.ok,
          action: (props) => props.hide()
        }
      },
      {
        afterHide: () => {
          router.navigate('/');
        }
      }
    );
  };

  requestVerification = (e) => {
    e.preventDefault();

    model.requestVerification((err, res) => {
      if (res?.ok) {
        this.setState({ resend: false });
      } else if (res?.expired) {
        model.setState({ resetExpired: res.expired });
        this.timer(() => model.state.resetExpired > Date.now(), intervalId);
      }
    });
  };

  renderNotice = () => {
    return (
      <>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t(LANG_CONST.email_verification)}</h4>
        </div>

        <form className='mc-form'>
          <pre className='mc-value-418'>{lang.t(LANG_CONST.notice.verification_email_sent)}</pre>
          <div className='mc-label-420'>
            <span className=''>{lang.t(LANG_CONST.notice.no_receive_email)} </span>{' '}
            <span
              onClick={() => {
                model.resetApiState('requestVerification');
                this.setState({ resend: true });
              }}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t(LANG_CONST.buttons.click_to_resend)}
            </span>
          </div>
        </form>
      </>
    );
  };

  renderEmailInput = () => {
    const apiStateId = 'requestVerification';
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    let { loading, invalid, error, errorMessage } = createState;

    const { blocked, expiredIn } = model.getBlock();

    if (error === 'BLOCKED') errorMessage = '';

    if (error === 'EMAIL_TAKEN') {
      invalid['email'] = errorMessage;
      error = null;
    }
    let blockedInMin = Math.ceil(expiredIn / 60);
    blockedInMin = `${blockedInMin} ${blockedInMin > 2 ? 'minutes' : 'minute'}`;

    return (
      <>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t(LANG_CONST.email_verification)}</h4>
        </div>
        {error && <p className='mc-error'>{errorMessage}</p>}
        <form className='mc-form' onSubmit={this.requestVerification}>
          <TextField
            template={6}
            name={'email'}
            value={model.input('email')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              model.setStateSilent({ resetExpired: 0 });
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={LANG_CONST.email_address}
            invalid={invalid}
          />
          {blocked && (
            <div className={'mc-label-418'}>
              {lang.t(LANG_CONST.notice.verify_code_sent_email, { blockedInMin })}
            </div>
          )}
          <MCButton
            large
            type='submit'
            radius
            disabled={blocked || loading}
            loading={loading}
            primary
            dark={!blocked}
            light={blocked}
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.resend_in, { duration: formatDuration(expiredIn) })
                : lang.t(LANG_CONST.buttons.resend)
            }
          />
        </form>
      </>
    );
  };

  render() {
    if (this.state.loading) {
      return (
        <div className={'mc-page-auth-box'}>
          <div className={'mc-m-auto'}>
            <Spinner />
          </div>
        </div>
      );
    }

    if (this.state.msg) {
      return (
        <div className='mc-primary-420' style={{ marginBottom: `calc(50vh - ${remCss(13)}px)` }}>
          <span>{lang.t(this.state.msg)}</span>
        </div>
      );
    }

    return (
      <div className={'mc-page-auth-box'}>
        {this.state.resend ? this.renderEmailInput() : this.renderNotice()}
      </div>
    );
  }
}

export default withRouter(EmailVerification);
